import React from "react";
import { Document, Page, Text, Font, View } from "@react-pdf/renderer";

import { styles } from "./AppStyleTax";
import {
  TableRow,
  TableHeaderTAX,
  TableTourName,
  FirstDeposit,
  TableTAXprice,
  TableRowTAX,
  InfoCompany,
  PriceList,
  HeadingWithColor,
  IterDetail,
  Detail2Column,
  PriceDetail,
} from "./TableCom";
import {
  FooterLine,
  HeaderCus,
  FooterLeft,
  FooterRight,
  FooterPageNum,
} from "./HeaderFooter";
import { UserInfo } from "./UserInfo";
import { gen_day, gen_day_vi } from "../../utils/dayshow";
import {
  PRICE_INCLUDE_VI,
  PRICE_EXCLUDE_VI,
  PRICE_TEMPLATE,
} from "../../utils/constTax";

export default function Annex({ data_pdf }) {
  if (data_pdf == null) {
    return null;
  } else {
    const day_showing = gen_day(data_pdf.day_start, data_pdf.activities.length);

    const day_showing_vi = gen_day_vi(
      data_pdf.day_start,
      data_pdf.activities.length,
    );
    const title_pdf = data_pdf.booking_number + ".pdf";

    const visible_items = (data_pdf.tax_data?.brief_itinerary || [])
      .map((item, originalIndex) => ({
        ...item,
        _originalIndex: originalIndex,
      }))
      .filter((item) => !item.no_show);

    return (
      <View>
        <Text style={styles.title}>PHỤ LỤC</Text>
        <Text style={styles.title_italic}>ANNEX</Text>

        <Text style={styles.normal}>
          Tên khách hàng{" "}
          <Text style={styles.normal_italic}>
            /Customer name: {data_pdf.tax_data?.customer_name}
          </Text>
        </Text>

        <Text style={styles.normal}>
          Mã đặt chỗ{" "}
          <Text style={styles.normal_italic}>
            /Booking REF: {data_pdf.tax_data?.contract_number}
          </Text>
        </Text>

        <Text style={styles.normal}>
          Số lượng khách: {data_pdf.no_of_client.split(" ")[0]} khách
        </Text>
        <Text style={styles.normal_italic}>
          Number of guests: {data_pdf.no_of_client.split(" ")[0]} guests
        </Text>

        <Text style={styles.normal}>
          Kiểu phòng{" "}
          <Text style={styles.normal_italic}>
            / Room type: {data_pdf.room_type}
          </Text>
        </Text>

        <TableHeaderTAX />
        {visible_items.map((item, visibleIndex) => (
          <TableRowTAX
            key={item._originalIndex}
            data={item}
            index={visibleIndex}
            day={
              data_pdf.day_start == null
                ? "Day " + (visibleIndex + 1)
                : day_showing[item._originalIndex].date
            }
            day_vi={
              data_pdf.day_start == null
                ? "Ngày " + (visibleIndex + 1)
                : day_showing_vi[item._originalIndex].date
            }
          />
        ))}
        {/* <TableTAXprice data={data_pdf.tax_data.price} /> */}
        <Text style={styles.normal_bold}>Giá</Text>
        <Text style={styles.normal_bold_italic}>Tour Price</Text>
        <Text style={styles.normal}>
          {data_pdf.tax_data.template_tax_price || PRICE_TEMPLATE}
        </Text>

        <Text style={styles.normal_bold}>Giá bao gồm</Text>
        <Text style={styles.normal_bold_italic}>Price includes</Text>
        <Text style={styles.normal}>
          {data_pdf?.tax_data?.template_tax_include_vi || PRICE_INCLUDE_VI}
        </Text>

        <Text style={styles.normal_bold}>Giá không bao gồm</Text>
        <Text style={styles.normal_bold_italic}>Price excludes</Text>

        <Text style={styles.normal}>
          {data_pdf?.tax_data?.template_tax_exclude_vi || PRICE_EXCLUDE_VI}
        </Text>

        <Text style={styles.normal_bold}>LỊCH TRÌNH</Text>
        <Text style={styles.normal_bold_italic}>ITINERARY</Text>

        {visible_items.map((item, visibleIndex) => (
          <div key={item._originalIndex}>
            <Text style={styles.normal_bold}>
              {"Ngày " + (visibleIndex + 1) + ": "}{" "}
              {item.activities_tax
                ? item?.activities_vi
                    ?.toUpperCase()
                    .replace("vi:", "")
                    .replace("vi", "")
                    .trim()
                    .split("(")[0]
                : item?.activities_no_tax_vi
                    ?.toUpperCase()
                    .replaceAll("\n", " ")
                    .split("(")[0]}
            </Text>
            <Text style={styles.normal_bold_italic}>
              {"Day " + (visibleIndex + 1) + ": "}{" "}
              {item.activities_tax
                ? item.activities
                    ?.toUpperCase()
                    .replaceAll("\n", " ")
                    .split("(")[0]
                : item.activities_no_tax
                    ?.toUpperCase()
                    .replaceAll("\n", " ")
                    .split("(")[0]}
            </Text>

            <Text style={styles.normal}>
              {item.activities_tax
                ? item?.detail_vi?.replace("vi:", "").replace("vi", "").trim()
                : item?.detail_no_tax_vi}
            </Text>
            <Text style={styles.normal_italic}>
              {item.activities_tax ? item?.detail : item?.detail_no_tax}
            </Text>
          </div>
        ))}
      </View>
    );
  }
}
